import { Component, OnChanges, EventEmitter, SimpleChange, Input, Output, OnDestroy, OnInit } from '@angular/core';
import {flatMap} from "tslint/lib/utils";
import { JourneyService } from '../../Services/journey.service';
declare let $;


@Component({
  selector: 'app-review-component',
  templateUrl: './review-component.component.html',
  styleUrls: ['./review-component.component.css']
})
export class ReviewComponentComponent implements OnInit, OnChanges, OnDestroy {
  gameTranscationMetadata: any;
  showEmbededComponents: boolean;
  showToolTip: boolean;

  constructor(private journeyService:JourneyService) {
    this.language = localStorage.getItem("defaultLang");
  }

  @Input() reviewCharacterSpeech : any;
  @Input() sceneNumber : number;
  @Input() reviewInput : Array<any> = [];
  @Input() reviewStatus : boolean;
  @Input() sceneCharacters : any;
  @Input() sceneInfoCharacters : any;
  @Input() selectedPath : any;
  // @Input() screenOrientataion : any;

  @Input() step_id: any;
  @Input() userID: any;
  @Input() community_id: any;
  @Input() journey_id: any;
  @Output() notifyToGameCharacterComponent = new EventEmitter<boolean>();
  @Output() reviewResponseSource = new EventEmitter<any>();
  tempArr : Array<any> = [];
  count : number;
  x : number;
  prefIndex : number = 0;
  defaultAnimationArray : Array<any> = [];
  intervalsArray : Array<any> = [];
  timeOutsArray : Array<any> = [];
  summeryFeedback : boolean = false;
  reviewArr : Array<any> = [];
  leftReviewArwBtn : boolean = true;
  digitWord = ['','First ','Second ','Third ','Fourth ', 'Fifth ','Sixth ','Seventh ','Eighth ','Ninth ','Tenth ','Eleventh ','Twelfth ','Thirteenth ','Fourteenth ','Fifteenth ','Sixteenth ','Seventeenth ','Eighteenth ','Nineteenth ', 'Twenty'];
  language: string = "";
  screenWidth : number = 1366;
  screenHeight : number;
  screenOrientataion:any = window.orientation;
  config1 = {
    textSize:6,
    numberSize:18,
    width:55,
    height:45,
    top:63,
    left:17,
    mtop:-45,
    lheight:13
  }
  config2 = {
    textSize:12,
    numberSize:30,
    width:57,
    height:10,
    top:43,
    left:27,
    mtop:10,
    lheight:22
  }

  
  ngOnInit(): void {
    if(this.step_id){
      this.journeyService.getGameTransactionData(this.step_id, this.userID, this.community_id, this.journey_id).pipe().subscribe(async (res: any) => {
        this.gameTranscationMetadata = await res.data.transactionData;
        this.showEmbededComponents = true;
      })
    }else{
      this.gameTranscationMetadata = {};
      this.gameTranscationMetadata.score = this.reviewCharacterSpeech.summaryFeedback.score;
      this.showEmbededComponents = true;
    }
    
  }
  ngOnChanges(changes : { [propertyName: string]: SimpleChange }){
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;
    for(let j = 0; j< this.intervalsArray.length; j++){
      clearInterval(this.intervalsArray[j]);
    }
    if(this.screenOrientataion == 90 && this.screenWidth < 1000){
      $('.responseBgContainer').css('top','42%');
      $('.responseBgContainer').css('height','auto');
      $('.gameContainer').css('height','calc(100vh - 66px)');
      $(".mobileSlideHeader").removeClass("headerShow");
    }
    if(this.sceneNumber > 0){
      this.leftReviewArwBtn = false;
    }else {
      this.leftReviewArwBtn = true;
    }
    this.reviewArr = [];
    this.reviewArr.push(this.reviewInput[this.sceneNumber]);
    if(this.reviewCharacterSpeech.endNode == "true" || this.reviewCharacterSpeech.endNode == true){
      this.summeryFeedback = true;
        $('.showSingle').removeClass('modalFooterActiveBtn');
        $('#showSingle5').addClass('modalFooterActiveBtn');
      if(this.screenOrientataion == 90 && this.screenWidth < 1000){
        $('.responseBgContainer').css('top','0%');
        $('.responseBgContainer').css('height','100%');
      }
    } else {
      this.summeryFeedback = false;
    }
    if(this.reviewCharacterSpeech){
      this.multipleCharacter();
    }
  }

  multipleCharacter(){
    $("#"+this.reviewCharacterSpeech.rootId).empty();
    $("#"+this.reviewCharacterSpeech.rootId).append('<div><audio style="display:none" id="myfirstaudio" controls><source src="" type="audio/mpeg"></audio></div>');
    $("#"+this.reviewCharacterSpeech.rootId).css('background-image','url('+this.sceneCharacters.bgImage.src+')');
    this.prefIndex = 0;
    var c,clist;
    // clist=this.reviewCharacterSpeech.characterSpeech;
    clist = [];
    for(let i=0; i< this.sceneInfoCharacters.length; i++){
      // let found = this.reviewCharacterSpeech.characterSpeech.find(char => char.name == this.sceneInfoCharacters[i].charName);
      var found = this.reviewCharacterSpeech.characterSpeech.slice().reverse().find(char => char.name == this.sceneInfoCharacters[i].charName);
      if(found && found.tone != 'Leaving the scene' && found.tone != 'Absent'){
        clist.push(found);
      }
    }
    for(c=0;c<clist.length;c++){
      var charId="myimg"+c;
      var ctooltipId="tooltip"+c;
      if(this.sceneInfoCharacters && this.sceneInfoCharacters.length > 2){
        $("#"+this.reviewCharacterSpeech.rootId).append('<div><div id="'+charId+'"><div class="parentbox"><div id="'+ctooltipId+'" class="speech-bubble-3Char childbox"></div></div></div></div>');
        // $(".speech-bubble-3Char").css("display","none");
      }else{
        $("#"+this.reviewCharacterSpeech.rootId).append('<div><div id="'+charId+'"><div class="parentbox"><div id="'+ctooltipId+'" class="speech-bubble childbox"></div></div></div></div>');
        // $(".speech-bubble").css("display","none");
      }

      let url = this.sceneCharacters[clist[c].name+'_'+clist[c].expression[0]].src;
      let name = clist[c].tone.toLowerCase();
      if(clist[c].tone == 'Absent' || name.includes("leaving") || name.includes("leave")){
        url = '';
      }
      $("#"+charId).css('background-image','url('+ url +')');
      $("#"+charId).css('height','320px');
      $("#"+charId).css('width','100%');
      $("#"+charId).css('background-position','0% 38%');
      $("#"+charId).css('position','absolute');
      this.tempArr=this.reviewCharacterSpeech.speechPreference.split('_');
      this.x = 0;
      this.count = 1;
      this.setInetrvalAn(charId, c, clist[c].frames[0],clist);
      if($("#"+ctooltipId).height() > 170){
        $("#"+ctooltipId).css('font-size', '12px');
      }
      if($("#"+ctooltipId).height() > 170){
        $("#"+ctooltipId).css('font-size', '11px');
      }
      if($("#"+ctooltipId).height() > 170){
        $("#"+ctooltipId).css('font-size', '10px');
      }
    }
    let totalChar = this.sceneInfoCharacters.length;
    if(this.screenOrientataion == 90 && this.screenWidth < 1000){
      if (totalChar == 1){
        $('#myimg0').addClass('myimg0_One');
        $('.parentbox').addClass('myImgParentBox');
      }else if (totalChar == 2){
        $('#myimg0').addClass('myimg0_Two');
        $('#myimg1').addClass('myimg1_Two');
        $('.parentbox').addClass('myImgParentBox_Two');
      }else if (totalChar == 3){
        $('#myimg0').addClass('myimg0_Three');
        $('#myimg1').addClass('myimg1_Three');
        $('#myimg2').addClass('myimg2_Three');
        $('.parentbox').addClass('myImgParentBox_Three');
      }else if (totalChar == 4){
        // $(".speech-bubble").css('width','150px');
        $(".speech-bubble-3Char").css('width','150px');
        $(".parentbox").css('left','51.5%');
      }
    }else {
      if (totalChar == 4){
        // $(".speech-bubble").css('width','120px');
        $(".speech-bubble-3Char").css('width','120px');
        $(".parentbox").css('left','40%');
      }else if (totalChar == 3){
        // $(".speech-bubble").css('width','145px');
        $(".speech-bubble-3Char").css('width','145px');
        $(".parentbox").css('left','48.5%');
      }
    }
    this.setLeftPost();
  }

  setInetrvalAn(charId, c, width, clist){

    let animation = setInterval(()=>{
      this.playSpriteImage(charId, width);
    }, 200);
    let ctooltipId="tooltip"+c;
    if(clist[c].text.length > 0 && clist[c].text[0] != ""){
      $("#"+ctooltipId).text(clist[c].text[0]);
      $("#"+ctooltipId).css("display","inline-block");
    }else
      $("#"+ctooltipId).css("display","none");

    this.defaultAnimationArray.push(animation);
    this.intervalsArray.push(animation);

  }

  setLeftPost(){
    let main=100;
    let totalChar = this.sceneInfoCharacters.length;
    let divisioncount=this.sceneInfoCharacters.length;
    let chasize=100;
    let sectionsize=main/divisioncount;
    let leftaddjest = sectionsize-chasize;
    leftaddjest=leftaddjest/2;

    if(this.screenOrientataion == 90 && this.screenWidth < 1000){
      //--------- For  mobile view
      for(let s=0;s<totalChar;s++){
        let left=0;
        left=left+leftaddjest;
        left=left+(sectionsize*s);
        $("#myimg"+s).css('left',left+'%');
      }
    }else {
      //--------- For Desktop view
      for(let s=0;s<totalChar;s++){
        let left=0;
        left=left+leftaddjest;
        left=left+(sectionsize*s);
        $("#myimg"+s).css('left',left+'%');
      }
    }

  }

  playSpriteImage(id, width){
    $("#"+id).css('background-position',''+this.x+'px 38%');
    if(this.count == width-1){
      this.x = 0;
      this.count = 1;
    }else{
      this.count = this.count+1;
      this.x = this.x-960;
    }
  }

  getScore(){
    return parseInt(this.reviewCharacterSpeech.summaryFeedback.score);
  }

  nextRes(e, data){
    this.reviewResponseSource.emit({linkTo: data.linkTo, count : this.sceneNumber, flag : "NEXT", prevNode : this.reviewCharacterSpeech.title});
    this.reviewCharacterSpeech = null;
  }

  prevRes(e, data){
    if(this.sceneNumber > 0){
      this.reviewResponseSource.emit({linkTo: data.linkTo, count : this.sceneNumber, flag : "PREV", prevNode : this.reviewCharacterSpeech.title});
      this.reviewCharacterSpeech = null;
    }
  }

  getDisableClass(i, ind){
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;
    if(this.screenOrientataion == 90 && this.screenWidth < 1000){
      $('.reviewFeedbackWrapper').css('top','8%');
    }
    let x = this.reviewArr.find(obj => obj.linkTo == i.linkTo);
    if (x){
      if(ind == 0){
        $('.responseArrowDwnBorder').css('left','16.8%');
        $('.responseArrowDwn').css('left','17%');
      }else if(ind == 1){
        $('.responseArrowDwnBorder').css('left','47.8%');
        $('.responseArrowDwn').css('left','48%');
      }else if(ind == 2){
        $('.responseArrowDwnBorder').css('left','79.8%');
        $('.responseArrowDwn').css('left','80%');
      }
      $('.responce'+ind).css('border', '2px solid #F8941E');
      $('#option'+ind).removeClass('volOff-icon');
      $('#option'+ind).addClass('volOn-icon');
      return false;
    } else {
      return true;
    }
  }

  openScoreboardModal(){
    this.notifyToGameCharacterComponent.emit(true)
  }

  ngOnDestroy(){
    for(let j = 0; j< this.intervalsArray.length; j++){
      clearInterval(this.intervalsArray[j]);
    }
    this.intervalsArray = [];
    this.defaultAnimationArray = [];
    this.reviewArr = [];
    this.sceneNumber = 0;
  }

  mouseenter(id) {
    if (id == 'moveLeftArrow' || id == 'moveRightArrow' || id == 'moveRightArrow1') {
      document.getElementById(id).style.filter = 'hue-rotate(45deg)';
    }
  }
  mouseleave(id) {
    if (id == 'moveLeftArrow' || id == 'moveRightArrow' || id == 'moveRightArrow1') {
      document.getElementById(id).style.filter = '';
    }
  }
  scorecardMouseEnter(){
    document.getElementById('scorcard-h').style.color = '#333333';
    document.getElementById('scorcard-i').style.filter = 'brightness(0.3)';
  }
  scorecardMouseLeave(){
    document.getElementById('scorcard-h').style.color = '#F8941E';
    document.getElementById('scorcard-i').style.filter = '';
  }

  mouseenterToolTip(ev: any) {
    const elementValue = ev.target.innerHTML;
    const element = ev.target;
    console.log('element', element)
    console.log('elementValue', elementValue)
    if (element.id == 'score-donut') {
      this.showToolTip = true;
    }
    let value = element.getBoundingClientRect();
    setTimeout(() => {
      let tooltipEle = document.getElementById('score-buttton');
      if (tooltipEle) {
        tooltipEle!.style.top = 220 + 'px';
        tooltipEle!.style.left = 90 + 'px';
        tooltipEle.style.width = 160 + 'px';
      }
      if (tooltipEle)
        tooltipEle!.style.zIndex = '10000';
      let tooltipTextElement = document.getElementById('score-buttton-text');
      if (element.id == 'score-donut') {
        if (tooltipTextElement) {
          tooltipTextElement!.innerHTML = 'Total points achieved by selecting unique choices in the game.';
          tooltipTextElement!.style.padding = '10px';
        }
      }
      else {
        this.showToolTip = false;
      }
    }, 0)
  }

  mouseleaveToolTip(ev) {
      let tooltipTextElement = document.getElementById('score-buttton-text');
    if (tooltipTextElement)
      tooltipTextElement!.style.padding = '0px';

    const elementValue = ev.target.innerHTML;
    if (elementValue != '') {
      this.showToolTip = false;
    }
    else {
      this.showToolTip = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/Screens/review-component/review-component.component.ts